import { useState } from 'react';
import Cookies from 'js-cookie';
import "./Quiz.css";

import svg3 from '../assets/svg/3.svg';
import squirrelBody from '../assets/images/squirrel-body.png';
import squirrelTail from '../assets/images/squirrel-tail.png';

function Quiz({ onSave }) {
	const [questions, setQuestions] = useState([
		{
			id: 1,
			question: 'Jak se jmenuje látka, která dává stromu jeho pevnost?',
			options: [
				'lenin',
				'lignin',
				'lenon'
			],
			answer: null,
			correct: 1
		},
		{
			id: 2,
			question: 'Jaké sovy můžete po setmění slyšet v Procháskově lesoparku?',
			options: [
				'kalouse ušatého a puštíka bělavého',
				'sovici sněžní a sovu pálenou',
				'výra velkého a puštíka obecného'
			],
			answer: null,
			correct: 2
		},
		{
			id: 3,
			question: 'Jak dlouho trvá většině lišejníků v ČR, než na stromě povyrostou o 1 cm?',
			options: [
				'cca půl roku',
				'1-10 let',
				'více jak 20 let'
			],
			answer: null,
			correct: 1
		},
		{
			id: 4,
			question: 'Proč se na podzim mění barva listí na stromech?',
			options: [
				'listy na podzim obsahují velké množství cukru',
				'způsobují to toxické látky, kterých se strom potřebuje zbavit',
				'v listech se rozkládá zelený chlorofyl a objevují se jiná barviva'
			],
			answer: null,
			correct: 2
		},
		{
			id: 5,
			question: 'Kteří ptáci umí udělat ve stromu dutiny?',
			options: [
				'strakapoudi',
				'sovy',
				'sýkorky'
			],
			answer: null,
			correct: 0
		},
		{
			id: 6,
			question: 'Proč mají stromy kůru?',
			options: [
				'aby je ochránila před škůdci a změnami teplot',
				'díky ní můžou rychle růst do výšky a do šířky',
				'kvůli zajištění pevnosti stromu'
			],
			answer: null,
			correct: 0
		},
		{
			id: 7,
			question: 'Jakou funkci mají žížaly a bakterie v půdě pod stromem?',
			options: [
				'svou přítomností ji spíše znehodnocují',
				'více méně žádnou, půda se bez nich obejde',
				'podílejí se na tvorbě půdy, zlepšují její kvalitu'
			],
			answer: null,
			correct: 2
		},
		{
			id: 8,
			question: 'Čaj z květů jakého stromu pomáhá při nachlazení?',
			options: [
				'lípa srdčitá',
				'jírovec maďal (kaštan)',
				'buk lesní'
			],
			answer: null,
			correct: 0
		},
		{
			id: 9,
			question: 'Proč stromy dokáží zpomalit globální změnu klimatu?',
			options: [
				'jejich spalováním se do vzduchu uvolňuje kyslík',
				'při fotosyntéze vážou do svého těla oxid uhličitý ze vzduchu',
				'na jejich listech dokáží zachytit prachové částice'
			],
			answer: null,
			correct: 1
		},
	]);

	// {} || or from cookies
	const [answers, setAnswers] = useState(() => {
		const json = Cookies.get('zs_answers');
		if (!json) return {};
		const as = JSON.parse(json);
		if (!as) return {};
		return as;
	});

	const [submitted, setSubmitted] = useState(false);
	const [result, setResult] = useState(0);

	// Save answer
	const handleAnswer = (i, j) => {
		const as = {
			...answers,
			[i]: j,
		}
		setAnswers(as);
		Cookies.set('zs_answers', JSON.stringify(as), { expires: 30 });
	}

	// Loop questions and set answer (option index)
	const handleSubmit = () => {
		const qs = [...questions];
		qs.map((q, i) => {
			q.answer = answers[i];
			return q;
		});
		setQuestions(qs);
		setSubmitted(true);
		if (window.congratulations) {
			window.congratulations.showModal();
		}

		const res = isFinished(qs) ? 1 : 2;
		setResult(res);
	}

	// We don't need save answers, they are already saved 
	// in cookies. So maybe for close modal or something.
	const handleSave = () => {
		if (onSave) {
			onSave();
		}
	}

	// Checking whether we have answered all the questions
	const isCompleted = () => {
		return Object.keys(answers).length === 9
	}

	const isFinished = (qs) => {
		return qs.filter(o => o.answer === o.correct).length === 9;
	}

	const isChecked = (i, j) => {
		return answers[i] === j;
	}

	const closeCongra = () => {
		window.congratulations.close();
	}

	return (
		<>
			<div className="quiz">
				<h2>Pojďte si vyplnit kvíz</h2>
				<p className="txt-center relative" style={{padding: "0 1.5em", marginBottom: "2em"}}>Pokud si nebudeš jistý správnou odpovědí, můžeš si kvíz uložit a&nbsp;probádat jednotlivé sekce znovu.
					<img src={svg3} style={{position: "absolute", top: "110%", left: "12%", maxWidth: "15%"}} alt="" />
				</p>
				{questions.map((q, i) => (
					<div key={q.id}>
						<div className="question">
							<div className="num">{i + 1}</div>
							<h3>{q.question}</h3>
							{q.options.map((answer, j) => (
								<label key={j} className={`answer radio ${q.answer === j && submitted ? (q.answer === q.correct ? 'correct' : 'incorrect') : '' }`}>
									{answer}
									<input
										type="radio"
										name={`q${q.id}`}
										onChange={() => handleAnswer(i, j)}
										checked={isChecked(i, j)}
									/>
									<span className="radio-toggle"></span>
								</label>
							))}
						</div>
						{ q.answer !== q.correct && result === 2 
						? <p className="incorrect" style={{marginTop: "-.75em", fontWeight: "300"}}>* Tato odpověď není správně, zkuste se vrátit a správnou odpověď si dohledat.</p>
						: <></>
						}
					</div>
				))}
				{ submitted && result === 2
				? <div className="incorrect txt-center">Opravte chybně vyplněné odpovědi a&nbsp;zkuste to znovu.</div>
				: <></>
				}
				<div className="flex justify-space-between">
					<button className="btn-circle" onClick={handleSave}>
						<span>Uložit na později</span>
					</button>
					<button className="btn-circle btn-green" onClick={handleSubmit} disabled={!isCompleted()}>
						<span>Odeslat stromům</span>
					</button>
				</div>
			</div>
			{ submitted && result === 1
			? 
				<dialog id="congratulations" open>
					<button className="close-btn" onClick={closeCongra}>&times;</button>
					<div className="dialog-body">
						<div className="txt-center">
							<h2 className="mb-0">Gratulujeme!</h2>
							<p>k úspěšnému vyplnění kvízu!</p>
							<p>Nyní se můžete dostavit na TIC Mikulov na Náměstí č. 1. Obdržíte od nás maličkost.</p>
							<div className="squirrel">
								<img src={squirrelBody} alt="" />
								<img src={squirrelTail} className="tail" alt="" />
							</div>
						</div>
					</div>
				</dialog>
			: <></>
			}
		</>
	);
}

export default Quiz;
